import { isLocalApi } from 'utils/localApi';

// Set REACT_APP_LOCAL_API_PROJECT_FORMS=true in .env.local for the local API.
export const PROJECT_FORMS_LOCAL_API_REQUESTS = isLocalApi(
  process.env.REACT_APP_LOCAL_API_PROJECT_FORMS
);
